import clsx from 'clsx'
import React, {useContext} from 'react'
import ClearableSelect from 'components/clearable-select'
import MenuItem from '@mui/material/MenuItem'

import {TeacherContext} from 'teacher/context'

export default function LessonFilter (props) {

  const {classes, onChange} = props
  const context = useContext(TeacherContext)
  const {query, translate} = context
  const lessons = context.query.unit && context.lessons
    ? context.lessons
    : []

  return (
    <ClearableSelect
      id="question-bank-lesson-filter"
      className={clsx(classes.select, "lesson")}
      value={query.lesson || ""}
      onChange={onChange}
      caption={translate('lesson-header')}
    >
      {lessons.map((lesson, key) => {
        const name = `${(key + 1).toString().padStart(2, '0')} - ${lesson.name}`
        return (<MenuItem value={lesson.id} key={key}>{name}</MenuItem>)
      })}
    </ClearableSelect>
  )
}
